
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse, HttpHeaders} from '@angular/common/http';  
import { HttpInterceptor } from '@angular/common/http'
 
@Injectable({
  providedIn: 'root'
})

export class AstrologyAppService
{
  base_url: any
  currentHoroscopeData: any
  private chartDbName = 'predictforme-chart-storage'
  private chartStoreName = 'charts'

  constructor(private http: HttpClient)
  {
    // this.base_url = 'http://localhost:4051/api/v1/'
    // this.base_url = 'http://10.0.2.2:3000/api/app/v1/'
  /*this.base_url = 'http://localhost:4050/api/v1/'*/
    this.base_url = 'https://astrologers.predictforme.com:4050/api/v1/'
  }

  async setCurrentHoroscope(data: any) {
    await this.setChartData('currentHoroscope', data);
    this.currentHoroscopeData = data;
  }

  async setChartData(key: string, data: any) {
    if (key === 'currentHoroscope') {
      this.currentHoroscopeData = data;
    }
    await this.saveLargeChartData(key, data);

    try {
      localStorage.setItem(key, JSON.stringify(data));
    } catch (error) {
      localStorage.removeItem(key);
    }
  }

  async getChartData(key: string) {
    if (key === 'currentHoroscope') {
      return this.getCurrentHoroscopeAsync();
    }

    var storedChart = await this.getLargeChartData(key);
    if (storedChart) {
      return storedChart;
    }

    if (localStorage.getItem(key)) {
      return JSON.parse(localStorage.getItem(key));
    }

    return null;
  }

  async getCurrentHoroscopeAsync() {
    if (this.currentHoroscopeData) {
      return this.currentHoroscopeData;
    }

    var storedChart = await this.getLargeChartData('currentHoroscope');
    if (storedChart) {
      this.currentHoroscopeData = storedChart;
      return storedChart;
    }

    return this.getCurrentHoroscope();
  }

  getCurrentHoroscope() {
    if (this.currentHoroscopeData) {
      return this.currentHoroscopeData;
    }

    if (localStorage.getItem('currentHoroscope')) {
      return JSON.parse(localStorage.getItem('currentHoroscope'));
    }

    return null;
  }

  private openChartDb(): Promise<IDBDatabase> {
    return new Promise((resolve, reject) => {
      if (!window.indexedDB) {
        reject('IndexedDB is not available');
        return;
      }

      var request = window.indexedDB.open(this.chartDbName, 1);

      request.onupgradeneeded = () => {
        var db = request.result;
        if (!db.objectStoreNames.contains(this.chartStoreName)) {
          db.createObjectStore(this.chartStoreName);
        }
      };

      request.onsuccess = () => resolve(request.result);
      request.onerror = () => reject(request.error);
    });
  }

  private async saveLargeChartData(key: string, data: any) {
    try {
      var db = await this.openChartDb();
      await new Promise<void>((resolve, reject) => {
        var transaction = db.transaction(this.chartStoreName, 'readwrite');
        var store = transaction.objectStore(this.chartStoreName);
        store.put(data, key);
        transaction.oncomplete = () => {
          db.close();
          resolve();
        };
        transaction.onerror = () => {
          db.close();
          reject(transaction.error);
        };
      });
    } catch (error) {
      /* IndexedDB is a large-data cache only; memory/localStorage fallbacks still keep the app usable. */
    }
  }

  private async getLargeChartData(key: string) {
    try {
      var db = await this.openChartDb();
      return await new Promise<any>((resolve, reject) => {
        var transaction = db.transaction(this.chartStoreName, 'readonly');
        var store = transaction.objectStore(this.chartStoreName);
        var request = store.get(key);
        request.onsuccess = () => {
          db.close();
          resolve(request.result);
        };
        request.onerror = () => {
          db.close();
          reject(request.error);
        };
      });
    } catch (error) {
      return null;
    }
  }

  

 
  login(dataObject)
  {
    return this.http.post(this.base_url + "loginAstrologer", dataObject)
  }

  authenticate_userastrologer()
  {
     //localStorage.setItem("token","JWT eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJfaWQiOiI2MGY2MTUyM2NhOGNiYTBmMTEzNDNmMzMiLCJuYW1lIjoidGVzdGluZyIsImVtYWlsX2lkIjoidGVzdGluZ0B0ZXN0aW5nLmNvbSIsInBob25lTnVtYmVyIjoiMTIzNDU2Nzg5MCIsInBhc3N3b3JkIjoiJDJiJDEwJEZZTTIyMHN4WTh1MmZxcVJUeEdEWk85RmM5YmQubzFyRWJQbjdFMjZFTWczMDJpSHNRL3VTIiwicmVFbnRlclBhc3N3b3JkIjoiJDJiJDEwJEZZTTIyMHN4WTh1MmZxcVJUeEdEWk85RmM5YmQubzFyRWJQbjdFMjZFTWczMDJpSHNRL3VTIiwiX192IjowfQ.O1-8Y82eAGVHUq3P3T1BcN0W--G6YA4a1qKt1SoGp8M")
     return this.http.post(this.base_url + "authenticate_userastrologer",{},
     {
       headers: new HttpHeaders(
       {
          Authorization: localStorage.getItem("token") || ''
       })
     })
  }

  getAstrologyChartsUser(data)
  {
     //localStorage.setItem("token","JWT eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJfaWQiOiI2MGY2MTUyM2NhOGNiYTBmMTEzNDNmMzMiLCJuYW1lIjoidGVzdGluZyIsImVtYWlsX2lkIjoidGVzdGluZ0B0ZXN0aW5nLmNvbSIsInBob25lTnVtYmVyIjoiMTIzNDU2Nzg5MCIsInBhc3N3b3JkIjoiJDJiJDEwJEZZTTIyMHN4WTh1MmZxcVJUeEdEWk85RmM5YmQubzFyRWJQbjdFMjZFTWczMDJpSHNRL3VTIiwicmVFbnRlclBhc3N3b3JkIjoiJDJiJDEwJEZZTTIyMHN4WTh1MmZxcVJUeEdEWk85RmM5YmQubzFyRWJQbjdFMjZFTWczMDJpSHNRL3VTIiwiX192IjowfQ.O1-8Y82eAGVHUq3P3T1BcN0W--G6YA4a1qKt1SoGp8M")
     return this.http.post(this.base_url + "getAstrologyChartsUser", data,
     )
  }

 getAstrologyChartsAdmin(data)
 {
    //localStorage.setItem("token","JWT eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJfaWQiOiI2MGY2MTUyM2NhOGNiYTBmMTEzNDNmMzMiLCJuYW1lIjoidGVzdGluZyIsImVtYWlsX2lkIjoidGVzdGluZ0B0ZXN0aW5nLmNvbSIsInBob25lTnVtYmVyIjoiMTIzNDU2Nzg5MCIsInBhc3N3b3JkIjoiJDJiJDEwJEZZTTIyMHN4WTh1MmZxcVJUeEdEWk85RmM5YmQubzFyRWJQbjdFMjZFTWczMDJpSHNRL3VTIiwicmVFbnRlclBhc3N3b3JkIjoiJDJiJDEwJEZZTTIyMHN4WTh1MmZxcVJUeEdEWk85RmM5YmQubzFyRWJQbjdFMjZFTWczMDJpSHNRL3VTIiwiX192IjowfQ.O1-8Y82eAGVHUq3P3T1BcN0W--G6YA4a1qKt1SoGp8M")
    return this.http.post(this.base_url + "getAstrologyChartsUser1", data,
    )
 }
 getAstrologylaganChartsAdmin(data)
 {
    //localStorage.setItem("token","JWT eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJfaWQiOiI2MGY2MTUyM2NhOGNiYTBmMTEzNDNmMzMiLCJuYW1lIjoidGVzdGluZyIsImVtYWlsX2lkIjoidGVzdGluZ0B0ZXN0aW5nLmNvbSIsInBob25lTnVtYmVyIjoiMTIzNDU2Nzg5MCIsInBhc3N3b3JkIjoiJDJiJDEwJEZZTTIyMHN4WTh1MmZxcVJUeEdEWk85RmM5YmQubzFyRWJQbjdFMjZFTWczMDJpSHNRL3VTIiwicmVFbnRlclBhc3N3b3JkIjoiJDJiJDEwJEZZTTIyMHN4WTh1MmZxcVJUeEdEWk85RmM5YmQubzFyRWJQbjdFMjZFTWczMDJpSHNRL3VTIiwiX192IjowfQ.O1-8Y82eAGVHUq3P3T1BcN0W--G6YA4a1qKt1SoGp8M")
    return this.http.post(this.base_url + "getAstrologylaganChartsUser", data,
    {
      headers: new HttpHeaders(
      {
         Authorization: localStorage.getItem("token") || ''
      })
    })
 }
  getAstrologyChartsAdminhouse(data)
  {
    //localStorage.setItem("token","JWT eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJfaWQiOiI2MGY2MTUyM2NhOGNiYTBmMTEzNDNmMzMiLCJuYW1lIjoidGVzdGluZyIsImVtYWlsX2lkIjoidGVzdGluZ0B0ZXN0aW5nLmNvbSIsInBob25lTnVtYmVyIjoiMTIzNDU2Nzg5MCIsInBhc3N3b3JkIjoiJDJiJDEwJEZZTTIyMHN4WTh1MmZxcVJUeEdEWk85RmM5YmQubzFyRWJQbjdFMjZFTWczMDJpSHNRL3VTIiwicmVFbnRlclBhc3N3b3JkIjoiJDJiJDEwJEZZTTIyMHN4WTh1MmZxcVJUeEdEWk85RmM5YmQubzFyRWJQbjdFMjZFTWczMDJpSHNRL3VTIiwiX192IjowfQ.O1-8Y82eAGVHUq3P3T1BcN0W--G6YA4a1qKt1SoGp8M")
    return this.http.post(this.base_url + "getAstrologyChartsUserhouse", data,
    {
      headers: new HttpHeaders(
      {
         Authorization: localStorage.getItem("token") || ''
      })
    })
  }
 getAstrologyHoraryChartsAdmin(data)
 {
    //localStorage.setItem("token","JWT eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJfaWQiOiI2MGY2MTUyM2NhOGNiYTBmMTEzNDNmMzMiLCJuYW1lIjoidGVzdGluZyIsImVtYWlsX2lkIjoidGVzdGluZ0B0ZXN0aW5nLmNvbSIsInBob25lTnVtYmVyIjoiMTIzNDU2Nzg5MCIsInBhc3N3b3JkIjoiJDJiJDEwJEZZTTIyMHN4WTh1MmZxcVJUeEdEWk85RmM5YmQubzFyRWJQbjdFMjZFTWczMDJpSHNRL3VTIiwicmVFbnRlclBhc3N3b3JkIjoiJDJiJDEwJEZZTTIyMHN4WTh1MmZxcVJUeEdEWk85RmM5YmQubzFyRWJQbjdFMjZFTWczMDJpSHNRL3VTIiwiX192IjowfQ.O1-8Y82eAGVHUq3P3T1BcN0W--G6YA4a1qKt1SoGp8M")
    return this.http.post(this.base_url + "getAstrologyHoraryChartsUser", data,
    {
      headers: new HttpHeaders(
      {
         Authorization: localStorage.getItem("token") || ''
      })
    })
 }

 getAstrologyChartsUserHoraryhouse(data)
 {
  return this.http.post(this.base_url + "getAstrologyChartsUserHoraryhouse", data,
    {
      headers: new HttpHeaders(
      {
         Authorization: localStorage.getItem("token") || ''
      })
    })
 }
  getAllMembersForSelectedUserWebapp()
  {
    return this.http.get(this.base_url + "get_all_members_for_selected_user_webapp",
    {
      headers: new HttpHeaders(
      {
         Authorization: localStorage.getItem("token") || ''
      })
    })
  }

  



savehoroscope(dataObjectVideo)
  {
    //localStorage.setItem("token","JWT eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJfaWQiOiI2MGY2MTUyM2NhOGNiYTBmMTEzNDNmMzMiLCJuYW1lIjoidGVzdGluZyIsImVtYWlsX2lkIjoidGVzdGluZ0B0ZXN0aW5nLmNvbSIsInBob25lTnVtYmVyIjoiMTIzNDU2Nzg5MCIsInBhc3N3b3JkIjoiJDJiJDEwJEZZTTIyMHN4WTh1MmZxcVJUeEdEWk85RmM5YmQubzFyRWJQbjdFMjZFTWczMDJpSHNRL3VTIiwicmVFbnRlclBhc3N3b3JkIjoiJDJiJDEwJEZZTTIyMHN4WTh1MmZxcVJUeEdEWk85RmM5YmQubzFyRWJQbjdFMjZFTWczMDJpSHNRL3VTIiwiX192IjowfQ.O1-8Y82eAGVHUq3P3T1BcN0W--G6YA4a1qKt1SoGp8M")
    var user = JSON.parse(localStorage.getItem("currentUser"));

    return this.http.post(this.base_url + "savehoroscope", dataObjectVideo,
    {
      headers: new HttpHeaders(
      {
         Authorization: user.token
      })
    })
  }
  getallcategory()
  {
    //localStorage.setItem("token","JWT eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJfaWQiOiI2MGY2MTUyM2NhOGNiYTBmMTEzNDNmMzMiLCJuYW1lIjoidGVzdGluZyIsImVtYWlsX2lkIjoidGVzdGluZ0B0ZXN0aW5nLmNvbSIsInBob25lTnVtYmVyIjoiMTIzNDU2Nzg5MCIsInBhc3N3b3JkIjoiJDJiJDEwJEZZTTIyMHN4WTh1MmZxcVJUeEdEWk85RmM5YmQubzFyRWJQbjdFMjZFTWczMDJpSHNRL3VTIiwicmVFbnRlclBhc3N3b3JkIjoiJDJiJDEwJEZZTTIyMHN4WTh1MmZxcVJUeEdEWk85RmM5YmQubzFyRWJQbjdFMjZFTWczMDJpSHNRL3VTIiwiX192IjowfQ.O1-8Y82eAGVHUq3P3T1BcN0W--G6YA4a1qKt1SoGp8M")
    var user = JSON.parse(localStorage.getItem("currentUser"));
    /* console.log(user.token); */
    return this.http.post(this.base_url + "getallcategory", 
    {
      headers: new HttpHeaders(
      {
         Authorization: user.token
      })
    })
  }

deletecategory(abc)
  {
    //localStorage.setItem("token","JWT eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJfaWQiOiI2MGY2MTUyM2NhOGNiYTBmMTEzNDNmMzMiLCJuYW1lIjoidGVzdGluZyIsImVtYWlsX2lkIjoidGVzdGluZ0B0ZXN0aW5nLmNvbSIsInBob25lTnVtYmVyIjoiMTIzNDU2Nzg5MCIsInBhc3N3b3JkIjoiJDJiJDEwJEZZTTIyMHN4WTh1MmZxcVJUeEdEWk85RmM5YmQubzFyRWJQbjdFMjZFTWczMDJpSHNRL3VTIiwicmVFbnRlclBhc3N3b3JkIjoiJDJiJDEwJEZZTTIyMHN4WTh1MmZxcVJUeEdEWk85RmM5YmQubzFyRWJQbjdFMjZFTWczMDJpSHNRL3VTIiwiX192IjowfQ.O1-8Y82eAGVHUq3P3T1BcN0W--G6YA4a1qKt1SoGp8M")
    var user = JSON.parse(localStorage.getItem("currentUser"));

    return this.http.post(this.base_url + "deletecategory", abc,
    {
      headers: new HttpHeaders(
      {
         Authorization: user.token
      })
    })
  }
  deletehoroscope(abc)
  {
    //localStorage.setItem("token","JWT eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJfaWQiOiI2MGY2MTUyM2NhOGNiYTBmMTEzNDNmMzMiLCJuYW1lIjoidGVzdGluZyIsImVtYWlsX2lkIjoidGVzdGluZ0B0ZXN0aW5nLmNvbSIsInBob25lTnVtYmVyIjoiMTIzNDU2Nzg5MCIsInBhc3N3b3JkIjoiJDJiJDEwJEZZTTIyMHN4WTh1MmZxcVJUeEdEWk85RmM5YmQubzFyRWJQbjdFMjZFTWczMDJpSHNRL3VTIiwicmVFbnRlclBhc3N3b3JkIjoiJDJiJDEwJEZZTTIyMHN4WTh1MmZxcVJUeEdEWk85RmM5YmQubzFyRWJQbjdFMjZFTWczMDJpSHNRL3VTIiwiX192IjowfQ.O1-8Y82eAGVHUq3P3T1BcN0W--G6YA4a1qKt1SoGp8M")
    var user = JSON.parse(localStorage.getItem("currentUser"));

    return this.http.post(this.base_url + "deletehoroscope", abc,
    {
      headers: new HttpHeaders(
      {
         Authorization: user.token
      })
    })
  }

getallhoroscope()
  {
    //localStorage.setItem("token","JWT eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJfaWQiOiI2MGY2MTUyM2NhOGNiYTBmMTEzNDNmMzMiLCJuYW1lIjoidGVzdGluZyIsImVtYWlsX2lkIjoidGVzdGluZ0B0ZXN0aW5nLmNvbSIsInBob25lTnVtYmVyIjoiMTIzNDU2Nzg5MCIsInBhc3N3b3JkIjoiJDJiJDEwJEZZTTIyMHN4WTh1MmZxcVJUeEdEWk85RmM5YmQubzFyRWJQbjdFMjZFTWczMDJpSHNRL3VTIiwicmVFbnRlclBhc3N3b3JkIjoiJDJiJDEwJEZZTTIyMHN4WTh1MmZxcVJUeEdEWk85RmM5YmQubzFyRWJQbjdFMjZFTWczMDJpSHNRL3VTIiwiX192IjowfQ.O1-8Y82eAGVHUq3P3T1BcN0W--G6YA4a1qKt1SoGp8M")
   // localStorage.setItem("token","JWT eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJfaWQiOiI2MGY2MTUyM2NhOGNiYTBmMTEzNDNmMzMiLCJuYW1lIjoidGVzdGluZyIsImVtYWlsX2lkIjoidGVzdGluZ0B0ZXN0aW5nLmNvbSIsInBob25lTnVtYmVyIjoiMTIzNDU2Nzg5MCIsInBhc3N3b3JkIjoiJDJiJDEwJEZZTTIyMHN4WTh1MmZxcVJUeEdEWk85RmM5YmQubzFyRWJQbjdFMjZFTWczMDJpSHNRL3VTIiwicmVFbnRlclBhc3N3b3JkIjoiJDJiJDEwJEZZTTIyMHN4WTh1MmZxcVJUeEdEWk85RmM5YmQubzFyRWJQbjdFMjZFTWczMDJpSHNRL3VTIiwiX192IjowfQ.O1-8Y82eAGVHUq3P3T1BcN0W--G6YA4a1qKt1SoGp8M")

    var user = JSON.parse(localStorage.getItem("currentUser"));
    /* console.log(user); */
    return this.http.post(this.base_url + "getallhoroscope", 
    {
      headers: new HttpHeaders(
      {
         Authorization: user.token
      })
    })
  }


  addnewcategory(dataObjectVideo)
  {
    //localStorage.setItem("token","JWT eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJfaWQiOiI2MGY2MTUyM2NhOGNiYTBmMTEzNDNmMzMiLCJuYW1lIjoidGVzdGluZyIsImVtYWlsX2lkIjoidGVzdGluZ0B0ZXN0aW5nLmNvbSIsInBob25lTnVtYmVyIjoiMTIzNDU2Nzg5MCIsInBhc3N3b3JkIjoiJDJiJDEwJEZZTTIyMHN4WTh1MmZxcVJUeEdEWk85RmM5YmQubzFyRWJQbjdFMjZFTWczMDJpSHNRL3VTIiwicmVFbnRlclBhc3N3b3JkIjoiJDJiJDEwJEZZTTIyMHN4WTh1MmZxcVJUeEdEWk85RmM5YmQubzFyRWJQbjdFMjZFTWczMDJpSHNRL3VTIiwiX192IjowfQ.O1-8Y82eAGVHUq3P3T1BcN0W--G6YA4a1qKt1SoGp8M")
    var user = JSON.parse(localStorage.getItem("currentUser"));

    return this.http.post(this.base_url + "addnewcategory", dataObjectVideo,
    {
      headers: new HttpHeaders(
      {
         Authorization: user.token
      })
    })
  }


  numerologyAlgorithmFunctionYear(dataObjectVideo)
  {
    //localStorage.setItem("token","JWT eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJfaWQiOiI2MGY2MTUyM2NhOGNiYTBmMTEzNDNmMzMiLCJuYW1lIjoidGVzdGluZyIsImVtYWlsX2lkIjoidGVzdGluZ0B0ZXN0aW5nLmNvbSIsInBob25lTnVtYmVyIjoiMTIzNDU2Nzg5MCIsInBhc3N3b3JkIjoiJDJiJDEwJEZZTTIyMHN4WTh1MmZxcVJUeEdEWk85RmM5YmQubzFyRWJQbjdFMjZFTWczMDJpSHNRL3VTIiwicmVFbnRlclBhc3N3b3JkIjoiJDJiJDEwJEZZTTIyMHN4WTh1MmZxcVJUeEdEWk85RmM5YmQubzFyRWJQbjdFMjZFTWczMDJpSHNRL3VTIiwiX192IjowfQ.O1-8Y82eAGVHUq3P3T1BcN0W--G6YA4a1qKt1SoGp8M")
    return this.http.post(this.base_url + "numerologyAlgorithmFunctionYear", dataObjectVideo,
    {
      headers: new HttpHeaders(
      {
         Authorization: localStorage.getItem("token") || ''
      })
    })
  }

  numerologyAlgorithmFunctionMonth(dataObjectVideo)
  {
    //localStorage.setItem("token","JWT eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJfaWQiOiI2MGY2MTUyM2NhOGNiYTBmMTEzNDNmMzMiLCJuYW1lIjoidGVzdGluZyIsImVtYWlsX2lkIjoidGVzdGluZ0B0ZXN0aW5nLmNvbSIsInBob25lTnVtYmVyIjoiMTIzNDU2Nzg5MCIsInBhc3N3b3JkIjoiJDJiJDEwJEZZTTIyMHN4WTh1MmZxcVJUeEdEWk85RmM5YmQubzFyRWJQbjdFMjZFTWczMDJpSHNRL3VTIiwicmVFbnRlclBhc3N3b3JkIjoiJDJiJDEwJEZZTTIyMHN4WTh1MmZxcVJUeEdEWk85RmM5YmQubzFyRWJQbjdFMjZFTWczMDJpSHNRL3VTIiwiX192IjowfQ.O1-8Y82eAGVHUq3P3T1BcN0W--G6YA4a1qKt1SoGp8M")
   
    return this.http.post(this.base_url + "numerologyAlgorithmFunctionMonth", dataObjectVideo,
    {
      headers: new HttpHeaders(
      {
         Authorization: localStorage.getItem("token") || ''
      })
    })
  }

numerologyAlgorithmFunctionDate(dataObjectVideo)
  {
    return this.http.post(this.base_url + "numerologyAlgorithmFunctionDate", dataObjectVideo,
    {
      headers: new HttpHeaders(
      {
         Authorization: localStorage.getItem("token") || ''
      })
    })
  }



  getAllVAWArticlesForSelectedCategory(dataObjectArticle)
  {
    return this.http.post(this.base_url + "get_all_vaw_articles_for_selected_category_webapp", dataObjectArticle,
    {
      headers: new HttpHeaders(
      {
         Authorization: localStorage.getItem("token") || ''
      })
    })
  }

  addMuhuratRequestWebapp(dataObject)
  {
    return this.http.post(this.base_url + "get_muhurat_webapp", dataObject,
    // return this.http.post(this.base_url + "add_muhurat_request_webapp", dataObject,
    {
      headers: new HttpHeaders(
      {
         Authorization: localStorage.getItem("token") || ''
      })
    }) 
  }

  getAllQuestionsForSelectedEvent(dataObjectEvent)
  { 
    return this.http.post(this.base_url + "get_all_questions_for_selected_event_webapp", dataObjectEvent,
    {
      headers: new HttpHeaders(
      {
         Authorization: localStorage.getItem("token") || ''
      })
    })
  }

  getAnswerWebapp(dataObjectQuestion)
  { 
    return this.http.post(this.base_url + "get_answer_webapp", dataObjectQuestion,
    {
      headers: new HttpHeaders(
      {
         Authorization: localStorage.getItem("token") || ''
      })
    })
  }

  changePasswordAstrologer(dataObject)
  {
    return this.http.post(this.base_url + "change_password_astrologer", dataObject,
    {
      headers: new HttpHeaders(
      {
         Authorization: localStorage.getItem("token") || ''
      })
    })
  }

  // getLatLong(selectedItem)
  // {
  //   // Given By Sir | Google Places API Key
  //   return this.http.get('https://maps.googleapis.com/maps/api/place/details/json?placeid=' + selectedItem.place_id + '&key=AIzaSyBOjeuwl6O9UgKLCoMJNzSOvhha8Jw-RxQ');
  // }
  
  getToken()
  {
    return localStorage.getItem("token");
  }

  intercept(req, next)
  {
    if (!this.getToken()) {
      return next.handle(req);
    }
    let tokenizedReq = req.clone(
      {
        setHeaders:
        {
          Authorization: `Bearer ${this.getToken()}`
        }
      }
    )

    return next.handle(tokenizedReq)
  }
}
